// removed by extract-text-webpack-plugin
module.exports = {"EkycPersonalInfo":"EkycPersonalInfo","backInRight":"backInRight","Title":"Title","FormLeft":"FormLeft","FormRight":"FormRight","input-group-text":"input-group-text","EkycPersonalInfoMobile":"EkycPersonalInfoMobile","form-row":"form-row"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step3/PersonalInfo/style.scss
// module id = 2311
// module chunks = 10